import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import Button from '@adsk/bim360-matrix-react-button';

import './_EntityBlockError.scss';

const EntityBlockError = ({ retry, className }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const classes = classNames('EntityBlockError', className);
  return (
    <div className={classes}>
      <span className="EntityBlockError__text">{T.translate('ERROR_LOADING')}</span>
      <Button
        className="EntityBlockError__button"
        styleType={Button.StyleType.INLINE_LINK}
        onClick={retry}
      >
        {T.translate('TRY_AGAIN')}
      </Button>
    </div>
  );
};

EntityBlockError.propTypes = {
  /**
   * A classname for this component
   */
  className: PropTypes.string,
  /**
   * Handler for retry fetching data
   */
  retry: PropTypes.func
};

export default EntityBlockError;
